import React, { useState, useEffect, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { setAlert } from '../../../actions/alert';
import { crearIngreso } from '../../../actions/ingresos';
import { filtrarMetodosConfiguracion } from '../../../actions/configuracion';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const NuevoIngreso = ({ ingreso, reestablecerIngreso }) => {

    const dispatch =  useDispatch();

    const { listado: listado_metodos } = useSelector(state => state.configuracion.metodos);

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [ingresoData, setIngresoData] = useState({
        concepto: '', 
        id_metodo: null,  
        monto: 0
    });

    const [metodoData, setMetodoData] = useState(null);
    const [metodosFilter, setMetodosFilter] = useState([]);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Crear ingreso */
    const handleAbrir = () => {
        dispatch(filtrarMetodosConfiguracion(4));
    }

    const handleInputChange = ({ target }) => {
        setIngresoData({
            ...ingresoData,
            [target.name]: target.value
        });
    }

    const handleSelectMetodo = (option) => {
        setIngresoData({
            ...ingresoData,
            id_metodo: option ? option.value : null
        });

        setMetodoData(option);
    }
    
    const handleNumberChange = (value) => {
        setIngresoData({
            ...ingresoData,
            monto: value || ''
        });
    }

    const handleProcesar = async () => {
        if(ingresoData.concepto && ingresoData.monto){
            await setStatusProcesar(true);
            await dispatch(crearIngreso(ingresoData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('El concepto y el monto son requeridos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setIngresoData({
                concepto: '', 
                id_metodo: null,  
                monto: 0
            });

            setMetodoData(null);

            setNuevoModal(false);
            reestablecerIngreso(null);
        }
    }

    useEffect(() => {
        if(ingreso){
            setNuevoModal(true);

            setIngresoData({
                ...ingresoData
            });
        }        
    }, [ingreso]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_metodos.length; i++) {
            options.push({ value: listado_metodos[i].id, label: listado_metodos[i].nombre });
        }

        setMetodosFilter(options);
    }, [listado_metodos]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .select-group {
                            height: 100%;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>
            <Modal show={nuevoModal} size="xl" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar ingreso</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 form-group mb-2">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Concepto" id="concepto" name="concepto" value={ingresoData.concepto} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="concepto">Concepto</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-3 form-group mb-2">
                            <div className="input-group h-100">
                                <Select
                                    name="id_metodo"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Método de pago"
                                    options={metodosFilter}
                                    value={metodoData}
                                    isClearable={true}
                                    onChange={(value) => handleSelectMetodo(value)}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{
                                        ValueContainer: CustomValueContainer
                                    }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-2">
                            <div className="input-group">
                                <div className="form-floating">
                                    <CurrencyInput
                                        id="monto"
                                        name="monto"
                                        className="form-control text-center"
                                        value={ingresoData.monto || ''}
                                        decimalsLimit={2}
                                        groupSeparator=","
                                        decimalSeparator="."
                                        onValueChange={(value) => handleNumberChange(value)}
                                    />
                                    <label htmlFor="monto">Monto</label>
                                </div>
                            </div>
                        </div>
                    </div>           
                </Modal.Body>
                <Modal.Footer>
                    {
                        statusProcesar ?
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar</button>
                        :
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Agregar</button>
                    }
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default NuevoIngreso;